/**
 * Import OL classes
 */
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector';
import {get as getProjection} from 'ol/proj';
import {bbox} from 'ol/loadingstrategy';
import VectorLayer from 'ol/layer/Vector';

/**
 * Import own classes
 */
import loadJSON from './loadData';
import {featureStyleCall} from '../features/featureStyle';
import {lang} from '/main';

/**
 * @param {string} layerFile
 * @return {Promise|*}
 */
export default async function createLayer(layerFile, onlyNischenstaende = false) {
  let mapLayer;
  let layerSource;
  let layerFormat;

  try {
    layerFile = layerFile.replace('../', './');

    const layer = await loadJSON(layerFile);

    /**
     * Check layer format
     */
    switch (layer['data']['type']) {
      case 'GeoJSON':
        layerFormat = new GeoJSON({
          featureProjection: getProjection('EPSG:3857'),
        });
        break;
      default:
        throw new Error(layer['data']['type'] + ' ' + lang['errorUnknownLayerFormat']);
    }

    const allFeatures = layerFormat.readFeatures(layer['data']['content']);

    const features = onlyNischenstaende
      ? allFeatures.filter(feature => feature.get('isNischenstand') === true)
      : allFeatures;

    /**
     * Check source type
     */
    switch (layer['data']['source']) {
      case 'Vector':
        layerSource = new VectorSource({
          features,
          strategy: bbox,
          overlaps: false,
        });
        break;
      default:
        throw new Error(layer['data']['source'] + ' ' + lang['errorUnknownSourceTypeForLayers']);
    }

    /**
     * Check layer type
     */
    switch (layer['type']) {
      case 'Vector':
        mapLayer = new VectorLayer({
          source: layerSource,
          updateWhileAnimating: true,
          updateWhileInteracting: true,
          style: featureStyleCall,
          name: layer['properties']['name'],
          declutter: true,
        });
        break;
      case 'Image':
        mapLayer = new VectorLayer({
          source: layerSource,
          renderBuffer: 200,
          updateWhileAnimating: true,
          updateWhileInteracting: true,
          style: featureStyleCall,
          name: layer['properties']['name'],
          declutter: true,
        });
        break;
      default:
        throw new Error(layer['type'] + ' ' + lang['errorUnknownLayerType']);
    }

    /**
     * Set base properties for layer
     */
    mapLayer.setOpacity(layer['properties']['opacity']);
    mapLayer.setVisible(layer['properties']['visible']);
    mapLayer.setZIndex(layer['properties']['zIndex']);
    mapLayer['baseLayer'] = layer['properties']['baseLayer'];
    layer['properties']['minResolution'] !== null ? mapLayer.setMinResolution(layer['properties']['minResolution']) : null;
    layer['properties']['maxResolution'] !== null ? mapLayer.setMaxResolution(layer['properties']['maxResolution']) : null;

    /**
     * Set optional properties
     */
    if (typeof layer['name'] !== 'undefined') {
      mapLayer.set('title', layer['name']);
    }
    if (typeof layer['properties']['navigator'] !== 'undefined') {
      mapLayer.set('navigator', layer['properties']['navigator']);
    }
    if (typeof layer['properties']['menu'] !== 'undefined') {
      mapLayer.set('menu', layer['properties']['menu']);
    }

    return mapLayer;
  } catch (err) {
    throw new Error('CreateLayer error: ' + err.message);
  }
}
